import { useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";
import { shopApi, useShopAuth } from "@/lib/shopAuth";
import ShopLayout from "./ShopLayout";
import { Button } from "@/components/ui/button";

export default function ShopVerify() {
  const [sp] = useSearchParams();
  const { applyToken } = useShopAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState("loading");
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return; done.current = true;
    const token = sp.get("token");
    if (!token) { setStatus("error"); return; }
    shopApi.post("/shop/auth/verify", { token })
      .then(({ data }) => { applyToken(data.token, data.customer); setStatus("ok"); setTimeout(() => navigate("/sklep/konto"), 1500); })
      .catch(() => setStatus("error"));
  }, [sp, applyToken, navigate]);

  return (
    <ShopLayout>
      <div className="mx-auto max-w-md px-4 py-20 text-center" data-testid="shop-verify">
        {status === "loading" && <Loader2 className="mx-auto h-10 w-10 animate-spin text-amber-400" />}
        {status === "ok" && <><CheckCircle2 className="mx-auto h-14 w-14 text-emerald-400" /><h1 className="mt-4 font-display text-2xl font-bold uppercase">Konto aktywowane!</h1><p className="mt-2 text-neutral-400">Przekierowujemy do Twojego konta…</p></>}
        {status === "error" && <><XCircle className="mx-auto h-14 w-14 text-rose-400" /><h1 className="mt-4 font-display text-2xl font-bold uppercase">Link nieprawidłowy</h1><p className="mt-2 text-neutral-400">Link aktywacyjny jest nieprawidłowy lub został już użyty.</p><Button className="mt-6 bg-amber-400 text-[#0D1117] font-bold" onClick={() => navigate("/sklep/logowanie")}>Przejdź do logowania</Button></>}
      </div>
    </ShopLayout>
  );
}
